import { C } from "../lib/colors.js";
import { TIER_ORDER, tagOwner } from "../lib/forecast/engines.js";
import { ui } from "../lib/telemetry/instrument.js";
import TierSelector from "./TierSelector.jsx";

/** A typed trigger's depth picker: a field of the scenario form, not the composer's choice. */
const TRIGGER_DEPTH_IDS = {
  toggle: ui("custom-trigger.depth-toggle"),
  menu: ui("custom-trigger.depth-menu"),
  option: ui("custom-trigger.depth-option"),
};

/**
 * The depth a typed trigger's scenario runs at — Quick unless the user picks Deep — as the
 * same "Depth: Quick ▾" menu the ask box uses. Renders nothing when only one depth is served.
 *
 * @param {{ orchestrators: string[], tier: "quick"|"deep", onChange: (tier: string) => void }} props
 */
export default function TriggerDepthSelect({ orchestrators, tier, onChange }) {
  const tiers = TIER_ORDER.filter((t) => {
    const o = tagOwner(t);
    return o && (orchestrators || []).includes(o);
  });
  if (tiers.length < 2) return null;
  return (
    <TierSelector
      tiers={tiers}
      current={tier}
      onSelect={onChange}
      C={C}
      align="start"
      placement="below"
      ids={TRIGGER_DEPTH_IDS}
    />
  );
}
